import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import React, { FC, useMemo } from 'react'
import styled from 'styled-components'
import { KVCameraView } from 'types'

import { CameraViewLabelInput } from './CameraViewLabelInput'
import { CameraViewNotesInput } from './CameraViewNotesInput'

const CameraViewSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  width: 100%;
`

export const CameraViewMenu: FC<{
  selectedCameraView: KVCameraView
}> = ({ selectedCameraView }) => {
  const { cameraViews } = useKestrelViewerContext()

  // Always get the current camera view data from the cameraViews array
  const currentCameraView = useMemo(() => {
    const found = cameraViews?.find((cv) => cv.id === selectedCameraView.id)
    if (!found) {
      return selectedCameraView
    }
    return found
  }, [cameraViews, selectedCameraView]) // Include selectedCameraView in dependencies

  return (
    <>
      <CameraViewLabelInput selectedCameraView={currentCameraView} />
      <CameraViewSection>
        <div>Notes</div>
        <CameraViewNotesInput selectedCameraView={currentCameraView} />
      </CameraViewSection>
    </>
  )
}
